import comp from "./HeroComponent";
export default comp;
